/* Popup newsletterowy.

   Zasady pokazywania:
   - raz na przegladarke (localStorage), chyba ze ktos go tylko zamknal -
     wtedy wraca po 14 dniach,
   - nie na koszyku, w kasie ani na stronach konta,
   - po 12 sekundach albo gdy kursor ucieka poza okno (exit intent).

   localStorage bywa zablokowany (tryb prywatny), wiec kazdy odczyt i zapis
   jest w try/catch - bez pamieci popup po prostu pokazuje sie raz na wizyte.
*/
(function () {
  var OPOZNIENIE = 12000;
  var DNI_PO_ZAMKNIECIU = 14;
  var KLUCZ_STAN = 'ciroa_popup_stan';
  var KLUCZ_WYSLANE = 'ciroa_popup_wyslane';

  var popup = document.getElementById('ciroa-popup');
  if (!popup) return;

  function czytaj(klucz) {
    try { return window.localStorage.getItem(klucz); } catch (e) { return null; }
  }
  function zapisz(klucz, wartosc) {
    try { window.localStorage.setItem(klucz, wartosc); } catch (e) { /* tryb prywatny */ }
  }
  function usun(klucz) {
    try { window.localStorage.removeItem(klucz); } catch (e) { /* tryb prywatny */ }
  }

  function blokowanaSciezka() {
    var s = window.location.pathname;
    return s.indexOf('/cart') === 0 || s.indexOf('/checkout') === 0 ||
           s.indexOf('/account') === 0 || s.indexOf('/challenge') === 0;
  }

  function wolnoPokazac() {
    var stan = czytaj(KLUCZ_STAN);
    if (!stan) return true;
    if (stan === 'zapisany') return false;
    var kiedy = parseInt(stan, 10);
    if (isNaN(kiedy)) return true;
    return Date.now() - kiedy > DNI_PO_ZAMKNIECIU * 86400000;
  }

  var ekrany = popup.querySelectorAll('[data-ekran]');
  function pokazEkran(nazwa) {
    for (var i = 0; i < ekrany.length; i++) {
      ekrany[i].hidden = ekrany[i].getAttribute('data-ekran') !== nazwa;
    }
  }

  var ostatnioAktywny = null;
  function otworz(ekran) {
    if (!popup.hidden) return;
    ostatnioAktywny = document.activeElement;
    pokazEkran(ekran);
    popup.hidden = false;
    document.body.classList.add('ciroa-popup-otwarty');
    var cel = popup.querySelector(ekran === 'zapis' ? 'input[type="email"]' : '[data-kopiuj]');
    if (cel) cel.focus();
  }

  function zamknij(zapamietaj) {
    if (popup.hidden) return;
    popup.hidden = true;
    document.body.classList.remove('ciroa-popup-otwarty');
    if (zapamietaj) zapisz(KLUCZ_STAN, String(Date.now()));
    if (ostatnioAktywny && ostatnioAktywny.focus) ostatnioAktywny.focus();
  }

  var zamykacze = popup.querySelectorAll('[data-zamknij]');
  for (var i = 0; i < zamykacze.length; i++) {
    zamykacze[i].addEventListener('click', function () { zamknij(true); });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') zamknij(true);
  });

  /* Kopiowanie kodu. Clipboard API dziala tylko po HTTPS i po gescie
     uzytkownika - oba warunki sa spelnione, ale i tak lapiemy odrzucenie. */
  var przyciskKodu = popup.querySelector('[data-kopiuj]');
  if (przyciskKodu) {
    przyciskKodu.addEventListener('click', function () {
      var kod = popup.getAttribute('data-kod');
      var info = przyciskKodu.querySelector('.ciroa-popup__kod-info');
      function potwierdz(tekst) {
        if (!info) return;
        info.textContent = tekst;
        setTimeout(function () { info.textContent = 'kliknij, aby skopiować'; }, 2500);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(kod).then(
          function () { potwierdz('skopiowano'); },
          function () { potwierdz('zaznacz i skopiuj ręcznie'); }
        );
      } else {
        potwierdz('zaznacz i skopiuj ręcznie');
      }
    });
  }

  /* Shopify po wyslaniu formularza przeladowuje strone z ?customer_posted=true.
     Flaga w localStorage mowi nam, ze to byl NASZ formularz, a nie ten ze stopki. */
  var formularz = popup.querySelector('form');
  if (formularz) {
    formularz.addEventListener('submit', function () { zapisz(KLUCZ_WYSLANE, '1'); });
  }

  var parametry = new URLSearchParams(window.location.search);
  if (parametry.get('customer_posted') === 'true' && czytaj(KLUCZ_WYSLANE) === '1') {
    usun(KLUCZ_WYSLANE);
    zapisz(KLUCZ_STAN, 'zapisany');
    otworz('kod');
    return;
  }

  /* Blad walidacji e-maila - Shopify renderuje formularz z form.errors.
     Popup musi wrocic otwarty, zeby komunikat mial sens. */
  if (popup.querySelector('.ciroa-popup__blad')) {
    usun(KLUCZ_WYSLANE);
    otworz('zapis');
    return;
  }

  if (blokowanaSciezka() || !wolnoPokazac()) return;

  var odpalony = false;
  function odpal() {
    if (odpalony) return;
    odpalony = true;
    otworz('zapis');
  }

  setTimeout(odpal, OPOZNIENIE);
  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && e.clientY <= 0) odpal();
  });
})();
